export default [
	{
		modulo: 9,
		privilegio: 62,
		routerName: 'admin-escolar-aluno',
		routerPath: '/admin-escolar-aluno',
		componentName: 'AdminEscolarAluno',
		componentPath: 'modules/layout/admin-escolar/aluno/main'
	},
	{
		modulo: 9,
		privilegio: 58,
		routerName: 'admin-escolar-curso',
		routerPath: '/admin-escolar-curso',
		componentName: 'AdminEscolarCurso',
		componentPath: 'modules/layout/admin-escolar/curso/main'
	},
	{
		modulo: 9,
		privilegio: 60,
		routerName: 'admin-escolar-disciplina',
		routerPath: '/admin-escolar-disciplina',
		componentName: 'AdminEscolarDisciplina',
		componentPath: 'modules/layout/admin-escolar/disciplina/main'
	},
	{
		modulo: 9,
		privilegio: 63,
		routerName: 'admin-escolar-matricula',
		routerPath: '/admin-escolar-matricula',
		componentName: 'AdminEscolarMatricula',
		componentPath: 'modules/layout/admin-escolar/matricula/main'
	},
	{
		modulo: 9,
		privilegio: 67,
		routerName: 'admin-escolar-pacote',
		routerPath: '/admin-escolar-pacote',
		componentName: 'AdminEscolarPacote',
		componentPath: 'modules/layout/admin-escolar/pacote-horas/main'
	},
	{
		modulo: 9,
		privilegio: 68,
		routerName: 'admin-escolar-habilitacao',
		routerPath: '/admin-escolar-habilitacao',
		componentName: 'AdminEscolarHabilitacao',
		componentPath: 'modules/layout/admin-escolar/habilitacao/main'
	},
	{
		modulo: 9,
		privilegio: 64,
		routerName: 'admin-escolar-pagamento',
		routerPath: '/admin-escolar-pagamento',
		componentName: 'AdminEscolarPagamento',
		componentPath: 'modules/layout/admin-escolar/pagamento/main'
	},
	{
		modulo: 9,
		privilegio: 69,
		routerName: 'admin-escolar-regulamento',
		routerPath: '/admin-escolar-regulamento',
		componentName: 'AdminEscolarRegulamento',
		componentPath: 'modules/layout/admin-escolar/regulamento/main'
	},
	{
		modulo: 9,
		privilegio: 72,
		routerName: 'admin-escolar-gestao-ensino',
		routerPath: '/admin-gestao-ensino',
		componentName: 'adminEscolarGestaoEnsino',
		componentPath: 'modules/layout/admin-escolar/gestao-ensino/main'
	},
]
